import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { IClinicChartingPreferences } from '@dataTypes/chartingPreferences.type'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

export const fetchChartingPreferencesApi = async (
  clinicId: string,
): Promise<
  ApiEnvelope<{ charting_preferences: IClinicChartingPreferences }>
> => {
  const response = await axios.get<
    ApiEnvelope<{ charting_preferences: IClinicChartingPreferences }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/charting-preferences/${clinicId}`)
  return response.data
}

export const saveChartingPreferencesApi = async (
  payload: Pick<
    IClinicChartingPreferences,
    'clinic_id' | 'charting_system' | 'treatment_plan'
  > & { updated_by?: string },
): Promise<
  ApiEnvelope<{ charting_preferences: IClinicChartingPreferences }>
> => {
  const response = await axios.put<
    ApiEnvelope<{ charting_preferences: IClinicChartingPreferences }>
  >(`${CLINIC_BUSINESS_API}/api/v1/clinic/charting-preferences`, payload)
  return response.data
}
